module.exports = __webpack_public_path__ + "static/media/google.e94ed01e.svg";